import React, { FC } from 'react'
import {
  PinInput as ChakraPinInput,
  PinInputField as ChakraPinInputField,
  PinInputProps,
  useTheme,
} from '@chakra-ui/react'

import { BasicComponentProps } from '../../common/types'
import { NucbaTheme } from '../../styles'

type PinInputOwnProps = {
  fields: number
}

const PinInput: FC<
  BasicComponentProps<Partial<PinInputProps>, PinInputOwnProps>
> = ({
  fields,
  isInvalid,
  ...rest
}) => {
    const {
      colors: { nucba },
    } = useTheme<NucbaTheme>()

    return (
      <ChakraPinInput
        type='number'
        errorBorderColor={nucba.primary}
        focusBorderColor={!isInvalid ? nucba.borderColor : nucba.primary}
        isInvalid={isInvalid}
        placeholder=''
        {...rest}
      >
        {Array(fields)
          .fill(0)
          .map(() => (
            <ChakraPinInputField
              minWidth={{ base: '40px', sm: '90px' }}
              height={{ base: '60px', sm: '121px' }}
              background={nucba.backgroundGradient}
              color={!isInvalid ? '#fff' : nucba.primary}
              borderColor={nucba.borderColor}
              borderRadius={{ base: '10px', sm: '26px' }}
              fontWeight={700}
              fontSize={{ base: 'xl', sm: '7xl' }}
              outline='none'
              key={Math.floor(Math.random() * 10000)}
            />
          ))}
      </ChakraPinInput>
    )
  }

export default PinInput
